import { SpokenAdvice } from '../translations-types';

const translations: SpokenAdvice = {
  configDescription:
    "Set the instruction (skill) the AI uses, and manage the on/off classifications for the customer and the specialist. These are sent to the AI together with the spoken notes and the customer's earlier products/treatments.",
  instruction: 'Instruction (skill)',
  instructionPlaceholder: 'Describe how the AI should write the advice…',
  customerClassifications: 'Customer classifications',
  employeeClassifications: 'Specialist classifications',
  classificationLabel: 'Label',
  addClassification: 'Add classification',
  knowledgeFiles: 'Knowledge files',
  knowledgeFilesHint:
    'Files the AI uses as extra knowledge (PDF, images, documents). PDF and images are read best; other documents may be limited — convert them to PDF for best results.',
  uploadFile: 'Upload file',
  saved: 'Saved',
  panelTitle: 'Client preparation card',
  record: 'Record',
  stopRecording: 'Stop recording',
  generating: 'Generating advice…',
  transcript: 'Transcript',
  advice: 'Advice',
  generated: 'Advice generated',
  generateError: 'Could not generate advice.',
  micError: 'No access to the microphone.',
};

export default translations;
